export const promotionCodeField = "promotionCode";

export const promotionCodeFormInputTestId = "components/fragments/argyle/PromotionCodeForm/Input";

export const promotionCodeFormLabelTestId = "components/fragments/argyle/PromotionCodeForm/Label";

export const promotionCodeFormButtonTestId = "components/fragments/argyle/PromotionCodeForm/Button";
